module.exports = __webpack_public_path__ + "img/pay.5a65c127.png";